import React, { Fragment } from 'react'
import withStyles from 'react-jss'
import classNames from 'classnames'

import { COURSE_PAGE_NAV_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'
import pageNavigationStyles from './pageNavigationStyles'
import CustomButton from '../custom-button/CustomButton'

const PageNavigation = withStyles(pageNavigationStyles)((props) => {
  const {
    classes,
    block,
    courseRefreshAppActive,
    toggleConfirmationModal,
    courseViewsStore: {
      seller,
      isOverviewPage,
      setOverviewPage,
      product = {},
      courseThemeData: { prefs: { showOverview } = {} },
      viewConfig: { isPayerCabinet },
    },
  } = props
  const { allowCourseReset } = product
  const containerClasses = classNames(
    COURSE_PAGE_NAV_CLASS_NAMES.containerClassName,
    classes.pageNavigation,
    block && classes.navigationBlock
  )
  const resetCourseContainer = classNames(
    COURSE_PAGE_NAV_CLASS_NAMES.resetContainerClassName,
    classes.pageNavigation,
    block && classes.navigationBlock,
    classes.withResetNavigation
  )

  return (
    <div className={containerClasses}>
      <div
        className={classNames(
          COURSE_PAGE_NAV_CLASS_NAMES.breadcrumbsContainerClassName,
          classes.pageNavigationBreadCrumb
        )}
      >
        {isPayerCabinet && (
          <Fragment>
            <a className={classes?.pageNavigationActiveItem} href={`/payer/s/${seller?.username}`}>
              {I18n.t('react.shared.my_account')}
            </a>
            <i className='fas fa-chevron-right' />
          </Fragment>
        )}
        {showOverview && isOverviewPage && (
          <div className={classes.pageNavigationCurrentItem}>{I18n.t('react.shared.course_overview')}</div>
        )}
        {showOverview && !isOverviewPage && (
          <Fragment>
            <div onClick={setOverviewPage} className={classes.pageNavigationActiveItem}>
              {I18n.t('react.shared.course_overview')}
            </div>
          </Fragment>
        )}
      </div>

      {isOverviewPage && courseRefreshAppActive && allowCourseReset && (
        <div className={resetCourseContainer}>
          <CustomButton outline rightAligned onClick={toggleConfirmationModal}>
            <i className='fas fa-undo-alt' />
            {I18n.t('react.shared.button.reset_course')}
          </CustomButton>
        </div>
      )}
    </div>
  )
})

export default PageNavigation
